import { styled } from 'styled-components';

import { ChevronIcon, ExternalLinkIcon } from '../../assets/icons';

type IconProps = {
  color: 'foraBlue' | 'white';
  fontSize: 'small' | 'standard' | 'medium' | 'large';
  iconLeft?: boolean;
};

export const Chevron = ({ color, fontSize, iconLeft = false }: IconProps) => (
  <StyledChevron
    width={iconWidthByFontSize[fontSize ?? 'standard']}
    marginLeft={iconLeft ? undefined : 6}
    marginRight={iconLeft ? 6 : undefined}
    color={color}
    variant="thin"
    direction={iconLeft ? 'left' : 'right'}
  />
);

export const ExternalLink = ({ color, fontSize, iconLeft }: IconProps) => (
  <ExternalLinkIcon
    color={color}
    marginLeft={iconLeft ? undefined : 6}
    marginRight={iconLeft ? 6 : undefined}
    width={iconWidthByFontSize[fontSize ?? 'standard']}
  />
);

export const StyledChevron = styled(ChevronIcon)`
  transform: translateX(0px);
  transition: transform 0.2s ease;
`;

const iconWidthByFontSize = {
  small: 10,
  standard: 10,
  medium: 14,
  large: 14,
};
